<template>
    <div class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div  v-if="isSidebarOpen" class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
            <a class="navbar-brand brand-logo aa" href="/#/ams/dashboard"><img src="@/assets/images/ams_new_logo.png"
                    alt="logo" /></a>
            <a class="navbar-brand brand-logo-mini" href="/#/ams/dashboard"><img src="@/assets/images/ams_new_logo.png"
                    alt="logo" /></a>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-stretch">
            <b-navbar-toggle target="" class="align-self-center">
                <span @click="toggleNavBar()" class="mdi mdi-menu"></span>
            </b-navbar-toggle>
            <div v-if="!isSidebarOpen" class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                <a class="navbar-brand brand-logo aa" href="/#/ams/dashboard"><img src="@/assets/images/ams_new_logo.png"
                    alt="logo" /></a>
                <a class="navbar-brand brand-logo-mini" href="/#/ams/dashboard"><img src="@/assets/images/ams_new_logo.png"
                    alt="logo" /></a>
              
            </div>
            <!-- <div v-else class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
              <a class="navbar-brand brand-logo aa" href="/#/ams/dashboard"><img src="@/assets/images/ams_new_logo.png"
                  alt="logo" /></a>
              <a class="navbar-brand brand-logo-mini" href="/#/ams/dashboard"><img src="@/assets/images/ams_new_logo.png"
                  alt="logo" /></a>
            </div> -->
            <ul class="navbar-nav navbar-nav-right">
                <li class="d-flex me-3 align-items-center gap-2 language-dropdown">
                    <b-dropdown variant="light" toggle-class="d-flex align-items-center gap-2"
                        menu-class="dropdown-menu flag-dropdown navbar-dropdown">
                        <template #button-content>
                            <div>
                                <span :class="selectedLanguage.flagClass"></span>
                                <span>{{ selectedLanguage.label }}</span>
                            </div>
                        </template>
                        <b-dropdown-item v-for="language in languages" :key="language.id"
                            @click="changeLanguage(language.id)">
                            <i :class="language.flagClass"></i> {{ language.label }}
                        </b-dropdown-item>
                    </b-dropdown>
                </li>
                <li class="nav-item nav-profile dropdown">
                    <b-nav-dropdown :offset="10" id="profileDropdown" toggle-class="dropdown-toggle"
                        menu-class="dropdown-menu navbar-dropdown">
                        <template #button-content>
                            <div class="nav-profile-img">
                                <img :src="profilePicture" alt="image" />
                            </div>
                            <div class="nav-profile-text">
                                <em>{{ userDetails }}</em>
                            </div>
                        </template>
                        <b-dropdown-item to="/ams/profile">
                            <img src="@/assets/images/icon/profile.svg" class="menu-icon-bar" />
                            <span>{{ $translate('profile') }}</span>
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="logout">
                            <img src="@/assets/images/icon/logout.svg" class="menu-icon-bar" />
                            <span>{{ $translate('logout') }}</span>
                        </b-dropdown-item>
                    </b-nav-dropdown>
                </li>
                <li class="nav-item dropdown notification">
                    <b-nav-dropdown id="notificationDropdown" toggle-class="nav-link count-indicator dropdown-toggle"
                        menu-class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list">
                        <template #button-content>
                            <div @click="updateCount()">
                                <i class="mdi mdi-bell-outline"></i>
                                <span class=" count-symbol badge rounded-pill badge-notification bg-danger"
                                    v-if="!!notificationCount">{{ notificationCount > 9 ? '9+' : notificationCount }}</span>
                            </div>
                        </template>
                        <h6 class="p-3 mb-0">{{ $translate('notifications') }}</h6>
                        <h4 v-if="notifications && !notifications.length" class="text-center">
                            {{ $translate('no_notifications') }}</h4>
                        <b-dropdown-divider></b-dropdown-divider>
                        <div class="notification-body">
                            <div v-for="(notification, index) in visibleNotifications" :key="index">
                                <b-dropdown-item
                                @click="navigate(notification)"
                                class="preview-item">
                                    <div class="preview-thumbnail">
                                        <img src="@/assets/images/icon/notification.svg" class="menu-icon-bar" />
                                    </div>
                                    <div
                                        class="preview-item-content d-flex align-items-start flex-column justify-content-center">
                                        <p class="text-gray ellipsis mb-0">
                                            <strong>{{ notification.data.name }}</strong> {{ notification.data.message }}
                                        </p>
                                    </div>
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </div>
                        </div>
                        <!-- <div> -->
                        <b-button class="w-100 m-0" v-if="notifications && notifications.length > 3"
                            @click="showAll = !showAll">
                            {{ showAll ? $translate("show_less") : $translate("show_all") }}
                        </b-button>
                        <!-- </div> -->
                    </b-nav-dropdown>
                </li>
            </ul>

            <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
                data-toggle="offcanvas">
                <span @click="toggleNavBarMobile()" class="mdi mdi-menu"></span>
            </button>
        </div>
    </div>
</template>
<script>
import { capitalCase, sentenceCase } from 'change-case'
import '@/assets/css/style.css'
import popupMixins from '@/mixins/popupMixins'
import '@/assets/vendors/mdi/css/materialdesignicons.min.css'
import defaultProfile from "@/assets/images/faces/face1.jpg"
export default {
    mixins: [popupMixins],
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            // sessionLogout: false,
            logoutTimer: null,
            searchQuery: '',
            paths: [],
            timer: null,
            sidebar: false,
            username: 'USERNAME',
            showAll: false,
            languages: [
                { id: 'en', label: 'English', flagClass: 'flag-uk' },
                { id: 'es', label: 'Español', flagClass: 'flag-spain' }
            ],
            selectedLanguage: '',
            isSidebarOpen: true
        }
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
        parseLinkName(x) {
            return capitalCase(
                sentenceCase(
                    x

                        .replace(/orders/g, 'activities')
                        .replace(/order/g, 'activity')
                )
            )
        },
    },
    computed: {
        profilePicture() {
            let image = this.$store.state.user?.profile_image
            return image ? image : defaultProfile
        },
        notifications() {
            return this.$store.state.notifications.items.data
        },
        toggleValue() {
            return this.$store.state.notifications.toggle
        },
        visibleNotifications() {
            return this.showAll ? this.notifications : this.notifications && this.notifications.slice(0, 3);
        },
        notificationCount() {
            return this.$store.state.notifications.count
        },
        user() {
            console.log(this.$store.state.user)
            return this.$store.state.user || {}
        },
        companySetting() {
            const data = this.$store.state.company.settings
            return data
        },
        userDetails() {
            let roleName = ''
            if (this.user.roles && this.user.roles.length > 0) {
                roleName = this.user.roles[0].role.name
            }
            return `${this.user.first_name} ${this.user.last_name} (${roleName}) ${this.companySetting.name}`
        },
    },

    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(val) {
                this.selectedLanguage = this.languages.find(language => language.id === val);
            }
        },
        $route() {
            this.calcPath()
        },
        toggleValue: {
            handler: function (val) {
               /*  this.$store.dispatch('notifications/fetchAll');
                if (val === 1) {
                    this.timer = setInterval(async () => {
                        await this.$store.dispatch('notifications/fetchAll');
                    }, 5000);
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                } */
            },
        },
    },
    mounted() {
        this.calcPath()
        this.$store.dispatch('company/fetch')
    },

    methods: {
        changeLanguage(obj) {
            if (this.$i18n.locale !== obj) {
                this.$i18n.locale = obj
                localStorage.setItem('language', obj)
                this.$router.go()
            }
        },
        calcPath() {
            // generate path
            let pathSplit = this.$route.path.split('/')
            pathSplit.splice(0, 1)
            let paths = []
            let runningPath = ''
            for (let segment of pathSplit) {
                runningPath += '/' + segment

                paths.push({
                    path: runningPath,
                    text: segment,
                })
            }
            this.paths = paths
        },

        toggleNavBar() {
            document.body.classList.toggle('sidebar-icon-only')
            this.isSidebarOpen = !this.isSidebarOpen;
            this.$emit('toggle-sidebar')
        },

        toggleNavBarMobile() {
            this.$emit('toggle-class')
        },
        updateCount() {
            this.$store.dispatch('notifications/updateCount')
        },
        async logout() {
            await this.$store.dispatch('logout')
            // if (this.sessionLogout) {
            //     this.doToast(
            //         this.$translate('session_expired'),
            //         this.$translate(`relogin_message`),
            //         'danger'
            //     )
            // }
            return false
        },
       async navigate(notification) {

            await this.$store.dispatch("orders/fetchById", notification.data.id);
            let order = this.$store.state.orders.item;
            await this.$store.dispatch('acitivityTypeDocStore/fetchdocumentsAll', {  activityTypeId : order.order_type_id,order_id :notification.data.id});
            const path = `/ams/${notification.data.module}${notification.data.redirect == 1 ? '/' + notification.data.id : ''}`;
            this.$router.push(path);
        }
    },
}
</script>